module.exports = __webpack_public_path__ + "static/media/me@1200x676.1e0b9a3f.jpg";